import { createContext, useContext } from 'react';
import type { LabReviewScope, LabsReviewModule } from '@ludolio/shared-labs';
import type { UnitsApiAdapter } from './api';
import type { UnitsCapabilities } from './capabilities';
import type { UnitsUser } from './types';

export interface UnitsLabsModule {
  review: LabsReviewModule;
  scope: LabReviewScope;
}

export interface UnitsModule {
  api: UnitsApiAdapter;
  capabilities: UnitsCapabilities;
  currentUser: UnitsUser | null;
  reportError(error: unknown): void;
  navigateToUnits(): void;
  navigateToUnit(unitId: string): void;
  getRegion?(unitRegion?: string | null): string | null | undefined;
  labs?: UnitsLabsModule;
}

export const UnitsModuleContext = createContext<UnitsModule | null>(null);

export function useUnitsModule(): UnitsModule {
  const module = useContext(UnitsModuleContext);
  if (!module) {
    throw new Error('Units views must be rendered inside UnitsProvider');
  }
  return module;
}
